export default __webpack_public_path__ + "static/media/s1.8e51e67d.jpg";